// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768';
const TABELA_URL = `${API_URL}/api/v1/premiacao/tabelas`;
const TABELA_VEICULO_URL = `${API_URL}/api/v1/premiacao/tabelas-veiculo`;
const INFRACAO_URL = `${API_URL}/api/v1/premiacao/infracoes`;
const INFRACAO_MOTORISTA_URL = `${API_URL}/api/v1/premiacao/infracoes-motorista`;
const CONSOLIDADO_URL = `${API_URL}/api/v1/datalake-transben/premiacao/consolidado`;
const VEICULOS_PROPRIOS_URL = `${API_URL}/api/v1/datalake-transben/premiacao/veiculos-proprios`;
const buildQueryUrl = (baseUrl, filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && String(item).trim() !== '') {
                    queryParams.append(key, String(item));
                }
            });
            return;
        }
        queryParams.append(key, String(value));
    });
    const query = queryParams.toString();
    return query ? `${baseUrl}?${query}` : baseUrl;
};
export const getPremiacaoTabelas = async (filters = {}) => {
    const response = await get(buildQueryUrl(TABELA_URL, filters));
    return response?.data || response || {};
};
export const getPremiacaoTabelaSegmentos = async () => {
    const response = await get(`${TABELA_URL}/segmentos`);
    const data = response?.data ?? response;
    return Array.isArray(data) ? data : [];
};
export const getPremiacaoTabelaNomes = async () => {
    const response = await get(`${TABELA_URL}/nomes`);
    const data = response?.data ?? response;
    return Array.isArray(data) ? data : [];
};
export const getPremiacaoTabelaById = async (id) => {
    const response = await get(`${TABELA_URL}/${id}`);
    return response?.data || response;
};
export const createPremiacaoTabela = async (payload) => {
    const response = await post(TABELA_URL, payload);
    return response?.data || response;
};
export const updatePremiacaoTabela = async (id, payload) => {
    const response = await put(`${TABELA_URL}/${id}`, payload);
    return response?.data || response;
};
export const deletePremiacaoTabela = async (id) => {
    const response = await deleteRequest(`${TABELA_URL}/${id}`);
    return response?.data || response;
};
export const getPremiacaoTabelaVeiculos = async (filters = {}) => {
    const response = await get(buildQueryUrl(TABELA_VEICULO_URL, filters));
    return response?.data || response || {};
};
export const getPremiacaoTabelaVeiculoById = async (id) => {
    const response = await get(`${TABELA_VEICULO_URL}/${id}`);
    return response?.data || response;
};
export const createPremiacaoTabelaVeiculo = async (payload) => {
    const response = await post(TABELA_VEICULO_URL, payload);
    return response?.data || response;
};
export const createPremiacaoTabelaVeiculoLote = async (payload) => {
    const response = await post(`${TABELA_VEICULO_URL}/lote`, payload);
    return response?.data || response;
};
export const createPremiacaoAssociacaoMatriz = async (payload) => {
    const response = await post(`${TABELA_VEICULO_URL}/associacao-matriz`, payload);
    return response?.data || response;
};
export const ASSOCIACAO_PREMIACAO_PAGE_SIZE = 200;
export const ASSOCIACAO_PREMIACAO_MAX_RECORDS = 5000;
export const getVeiculosPropriosPremiacao = async (filters = {}) => {
    const response = await get(buildQueryUrl(VEICULOS_PROPRIOS_URL, filters));
    return response?.data || response || {};
};
export const updatePremiacaoTabelaVeiculo = async (id, payload) => {
    const response = await put(`${TABELA_VEICULO_URL}/${id}`, payload);
    return response?.data || response;
};
export const deletePremiacaoTabelaVeiculo = async (id) => {
    const response = await deleteRequest(`${TABELA_VEICULO_URL}/${id}`);
    return response?.data || response;
};
export const getInfracaoPremiacoes = async (filters = {}) => {
    const response = await get(buildQueryUrl(INFRACAO_URL, filters));
    return response?.data || response || {};
};
export const getInfracaoPremiacaoById = async (id) => {
    const response = await get(`${INFRACAO_URL}/${id}`);
    return response?.data || response;
};
export const createInfracaoPremiacao = async (payload) => {
    const response = await post(INFRACAO_URL, payload);
    return response?.data || response;
};
export const updateInfracaoPremiacao = async (id, payload) => {
    const response = await put(`${INFRACAO_URL}/${id}`, payload);
    return response?.data || response;
};
export const deleteInfracaoPremiacao = async (id) => {
    const response = await deleteRequest(`${INFRACAO_URL}/${id}`);
    return response?.data || response;
};
export const getInfracaoMotoristaPremiacoes = async (filters = {}) => {
    const response = await get(buildQueryUrl(INFRACAO_MOTORISTA_URL, filters));
    return response?.data || response || {};
};
export const getInfracaoMotoristaPremiacaoById = async (id) => {
    const response = await get(`${INFRACAO_MOTORISTA_URL}/${id}`);
    return response?.data || response;
};
export const createInfracaoMotoristaPremiacao = async (payload) => {
    const response = await post(INFRACAO_MOTORISTA_URL, payload);
    return response?.data || response;
};
export const updateInfracaoMotoristaPremiacao = async (id, payload) => {
    const response = await put(`${INFRACAO_MOTORISTA_URL}/${id}`, payload);
    return response?.data || response;
};
export const deleteInfracaoMotoristaPremiacao = async (id) => {
    const response = await deleteRequest(`${INFRACAO_MOTORISTA_URL}/${id}`);
    return response?.data || response;
};
export const getPremiacaoConsolidado = async (filters = {}) => {
    const response = await get(buildQueryUrl(CONSOLIDADO_URL, filters));
    const data = response?.data ?? response;
    return Array.isArray(data) ? data : [];
};
export const importarPremiacaoTabelas = async (formData) => {
    const response = await post(`${TABELA_URL}/importacao`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response?.data || response;
};
export const importarPremiacaoTabelaVeiculos = async (formData) => {
    const response = await post(`${TABELA_VEICULO_URL}/importacao`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response?.data || response;
};
export const importarInfracaoMotoristaPremiacoes = async (formData) => {
    const response = await post(`${INFRACAO_MOTORISTA_URL}/importacao`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response?.data || response;
};
export const importarInfracaoPremiacoes = async (formData) => {
    const response = await post(`${INFRACAO_URL}/importacao`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response?.data || response;
};
export const exportarLayoutImportacaoPremiacaoTabelasComRegistros = async () => {
    const response = await get(`${TABELA_URL}/importacao/layout-com-registros`, { responseType: 'blob' });
    return response?.data || response;
};
export const exportarLayoutImportacaoPremiacaoTabelaVeiculosComRegistros = async () => {
    const response = await get(`${TABELA_VEICULO_URL}/importacao/layout-com-registros`, { responseType: 'blob' });
    return response?.data || response;
};
export const exportarLayoutImportacaoInfracaoPremiacoesComRegistros = async () => {
    const response = await get(`${INFRACAO_URL}/importacao/layout-com-registros`, { responseType: 'blob' });
    return response?.data || response;
};
export const exportarLayoutImportacaoInfracaoMotoristaComRegistros = async () => {
    const response = await get(`${INFRACAO_MOTORISTA_URL}/importacao/layout-com-registros`, { responseType: 'blob' });
    return response?.data || response;
};
